import { render, staticRenderFns } from "./GlobalTags.vue?vue&type=template&id=798bd47e&lang=pug&"
import script from "./GlobalTags.vue?vue&type=script&lang=js&"
export * from "./GlobalTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports